/**
 * [polecenie właściciela 2026-09-14] PUBLICZNA strona podpisu online (`/podpis/:token`) — warstwa API.
 * Trasa backendu: `api/public/podpis/{token}` ([AllowAnonymous]; jedyną bramką jest token linku).
 *
 * Wywołania idą przez WSPÓLNĄ instancję axiosa (interceptor JWT dokłada token, jeśli ktoś jest zalogowany —
 * backend go ignoruje). Końcówki publiczne odpowiadają 404 (obcy token) i 400 (błędny kod, wygasły link),
 * NIGDY 401 — więc interceptor odświeżania sesji nie ma czego przechwycić i strona bez logowania działa.
 */
export function attach(api) {
    return {
        /** Stan + dane do ekranu (pierwsze wejście = zdarzenie „otwarto link”). 404 = nieznany/obcy token. */
        getPodpisPubliczny: (token) => api.get(`/public/podpis/${encodeURIComponent(token)}`),
        /** PDF do zapoznania się — `blob`, ramka na stronie. */
        getPodpisPublicznyPdf: (token) => api.get(`/public/podpis/${encodeURIComponent(token)}/pdf`, { responseType: "blob" }),
        /** Kod jednorazowy SMS-em na numer strony (limit 3/h liczy serwer). */
        sendPodpisPublicznyKod: (token) => api.post(`/public/podpis/${encodeURIComponent(token)}/kod`),
        /** Kod + akceptacja = podpis; 400 z liczbą pozostałych prób przy błędnym kodzie. */
        confirmPodpisPubliczny: (token, kod, akceptacja) =>
            api.post(`/public/podpis/${encodeURIComponent(token)}/potwierdz`, { kod, akceptacja: !!akceptacja }),
        /** Odmowa podpisu z powodem — wydający dostaje powiadomienie. */
        rejectPodpisPubliczny: (token, powod) =>
            api.post(`/public/podpis/${encodeURIComponent(token)}/odrzuc`, { powod: powod || null }),
    };
}
